export function stringify(data, replacer, space) {
    var indent = '';
    if (typeof space === 'number') {
        indent = ' '.repeat(space);
    }
    else if (typeof space === 'string') {
        indent = space;
    }
    var newline = indent ? '\n' : '';
    var colon = indent ? ': ' : ':';
    var internalData = data;
    function internalStringify(dataI, depth) {
        var _a, _b;
        if (dataI === null)
            return 'null';
        if (Number.isNaN(dataI))
            return 'null';
        if (dataI === Infinity)
            return 'null';
        if (typeof dataI === 'string')
            return "\"".concat(dataI.replace(/"/g, '\\"'), "\"");
        if (typeof dataI === 'number')
            return String(dataI);
        if (typeof dataI === 'boolean')
            return dataI ? 'true' : 'false';
        if (Array.isArray(dataI)) {
            var result = '[';
            for (var i = 0; i < dataI.length; i += 1) {
                if (i > 0)
                    result += ',';
                if (indent)
                    result += newline + indent.repeat(depth + 1);
                if (dataI[i] === undefined ||
                    Number.isNaN(data[i]) ||
                    dataI[i] === Infinity) {
                    result += 'null';
                }
                else {
                    result += (_a = internalStringify(dataI[i], depth + 1)) !== null && _a !== void 0 ? _a : 'null';
                }
            }
            if (indent && dataI.length > 0)
                result += newline + indent.repeat(depth);
            result += ']';
            return result;
        }
        if (typeof dataI === 'object') {
            var result = '{';
            var keys = replacer && Array.isArray(replacer) ? replacer : Object.keys(dataI);
            for (var i = 0; i < keys.length; i += 1) {
                var key = keys[i];
                if (dataI[key] !== undefined) {
                    if (i > 0)
                        result += ',';
                    if (indent)
                        result += newline + indent.repeat(depth + 1);
                    result += "".concat(internalStringify(key, depth + 1)).concat(colon).concat((_b = internalStringify(dataI[key], depth + 1)) !== null && _b !== void 0 ? _b : 'null');
                }
            }
            if (indent && keys.length > 0)
                result += newline + indent.repeat(depth);
            result += '}';
            return result;
        }
        return '{}';
    }
    if (typeof replacer === 'function') {
        internalData = (function recursiveReplacer(key, value) {
            if (value && typeof value === 'object') {
                Object.keys(value).forEach(function (k) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        value[k] = recursiveReplacer(k, value[k]);
                    }
                });
            }
            return replacer(key, value);
        })('', data);
    }
    return internalStringify(internalData, 0);
}
